import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TenantService } from './services/tenant/tenant.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    public translateService: TranslateService,
    public tenantService: TenantService
  ) {
    this.translateService.use(localStorage.getItem('lang') || 'en');
    this.tenantService.getTenantConfig();
  }
}
